/**
 * Strict URL-dispatcher routes use a static path (e.g. `/foo.html`) without `:param` segments.
 * Vue Router then clears `route.params`; mapUrl stores the mapped params on `meta.dispatcherParams`.
 * Merge with `route.params` so `/p/:parentSku/...` style routes still win when both exist.
 *
 * Kept in this file (not `index.ts`) so callers can import it without pulling `index.ts`, which
 * imports `router` from `app` and can create a circular init where barrel exports are undefined.
 */
export function getUrlDispatcherRouteParams (route: {
  params?: Record<string, string>
  meta?: { dispatcherParams?: Record<string, string> }
}): Record<string, string> {
  const dp = route.meta && route.meta.dispatcherParams ? route.meta.dispatcherParams : {}
  return Object.assign({}, dp, route.params || {})
}
